import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from "react";
import usePochtaTheme from "./usePochtaTheme";
export var ControlsContext = /*#__PURE__*/React.createContext({});

var useControls = function useControls() {
  var _ref2;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      size = _ref.size,
      columns = _ref.columns,
      vertical = _ref.vertical,
      gap = _ref.gap;

  var context = useContext(ControlsContext);
  var form = usePochtaTheme().componentsTokens.form;
  return _objectSpread(_objectSpread({}, context), {}, {
    // eslint-disable-next-line unicorn/explicit-length-check
    size: size || context.size || form.defaultSize,
    vertical: (_ref2 = vertical !== null && vertical !== void 0 ? vertical : context.vertical) !== null && _ref2 !== void 0 ? _ref2 : form.vertical,
    columns: columns || context.columns || form.defaultColumns,
    gap: gap || context.gap || form.defaultGap
  });
};

export default useControls;